export default __webpack_public_path__ + "static/media/image03.a09ecb48.png";